'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationPower = function NotificationPower(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z' })
  );
};
NotificationPower = (0, _pure2.default)(NotificationPower);
NotificationPower.displayName = 'NotificationPower';
NotificationPower.muiName = 'SvgIcon';

exports.default = NotificationPower;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/notification/power.js
// module id = 2612
// module chunks = 0